module.exports = __webpack_public_path__ + "img/latest_newsd_ctx.887c3e9.png";